// Données de démonstration : utilisées par les tests ET par le mode démo du back-office.
// Sites web vérifiés le 11/09/2026 ; tout le reste (réseaux, adresses, logos) est À COMPLÉTER
// dans le back-office. Le logo BJBS pointe encore vers l'hébergement Signitic : à ré-héberger
// AVANT la résiliation (les images img.signitic.app disparaîtront avec l'abonnement).
import type { Brand, Campaign, Person } from './types.ts';

const brandDefaults = {
  logo_url: null,
  logo_width: 145,
  logo_height: null,
  primary_color: '#000000',
  accent_color: '#7e8c8d',
  font_family: 'Arial, Helvetica, sans-serif',
  website_url: null,
  instagram_url: null,
  facebook_url: null,
  linkedin_url: null,
  tiktok_url: null,
  address: null,
  phone: null,
  legal_mention: null,
  layout: 'classic' as const,
  is_default: false,
  // Valeurs de la migration 20260917 pour une charte existante : rendu inchangé (voir core_test.ts).
  name_color: null,
  title_color: null,
  body_color: null,
  social_color: '#000000',
  separator_style: 'line' as const,
  separator_color: null,
  separator_width: 2,
  separator_gap: 16,
  logo_position: 'left' as const,
  blocks: null,
  layout_tree: null,
  styles: null,
};

export const demoBrands: Brand[] = [
  {
    ...brandDefaults,
    id: 'bjbs',
    name: 'BONJOUR/BONSOIR',
    domains: ['bonjourbonsoir.paris'],
    logo_url: 'https://img.signitic.app/uploads/ac9c7b9ead20733b86632de73c639c9b.png',
    logo_width: 145,
    logo_height: 94,
    website_url: 'https://bonjourbonsoir.paris/',
    linkedin_url: 'https://fr.linkedin.com/company/bonjour-bonsoir',
    is_default: true,
  },
  {
    ...brandDefaults,
    id: 'badaboum',
    name: 'BADABOUM',
    domains: ['badaboum.paris'],
    website_url: 'https://badaboum.paris/',
    instagram_url: 'https://www.instagram.com/badaboum.paris/',
  },
  {
    ...brandDefaults,
    id: 'virage',
    name: 'VIRAGE',
    domains: ['virage17.paris'],
    primary_color: '#000000',
    accent_color: '#c0398f',
    website_url: 'https://www.virage17.paris/',
  },
  {
    ...brandDefaults,
    id: 'panic-room',
    name: 'PANIC ROOM',
    domains: [],
    website_url: 'https://bonjourbonsoir.paris/lieux/panic-room/',
  },
  {
    ...brandDefaults,
    id: 'la-casbah',
    name: 'LA CASBAH',
    domains: [],
    website_url: 'https://bonjourbonsoir.paris/lieux/la-casbah/',
  },
];

const personDefaults = {
  kind: 'person' as const,
  send_as_emails: [] as string[],
  local_last_seen_at: null,
  display_name: null,
  phone_mobile: null,
  phone_office: null,
  brand_id: null,
  active: true,
  managed: true,
  no_banner: false,
  local_client: false,
};

export const demoPeople: Person[] = [
  {
    ...personDefaults,
    id: '00000000-0000-4000-8000-000000000001',
    primary_email: 'contact@bonjourbonsoir.paris',
    kind: 'shared',
    first_name: null,
    last_name: null,
    display_name: 'BONJOUR/BONSOIR',
    job_title: 'Nous contacter',
    install_token: 'demo-contact',
    public_token: 'pub-contact',
  },
  {
    ...personDefaults,
    id: '00000000-0000-4000-8000-000000000002',
    primary_email: 'prenom.n@bonjourbonsoir.paris',
    first_name: 'Prénom',
    last_name: 'Nom',
    job_title: 'Direction',
    phone_mobile: '06 00 00 00 00',
    send_as_emails: ['prenom.n@bonjourbonsoir.paris', 'prenom.n@badaboum.paris'],
    local_last_seen_at: '2026-09-12T18:20:00+02:00', // écrit aussi depuis Apple Mail
    install_token: 'demo-direction',
    public_token: 'pub-direction',
  },
  {
    ...personDefaults,
    id: '00000000-0000-4000-8000-000000000003',
    primary_email: 'booking@badaboum.paris',
    first_name: 'Camille',
    last_name: 'Exemple',
    job_title: 'Booking',
    install_token: 'demo-badaboum',
    public_token: 'pub-badaboum',
  },
  {
    ...personDefaults,
    id: '00000000-0000-4000-8000-000000000004',
    primary_email: 'prog@virage17.paris',
    first_name: 'Sacha',
    last_name: 'Exemple',
    job_title: 'Programmation',
    install_token: 'demo-virage',
    public_token: 'pub-virage',
  },
];

export const demoCampaigns: Campaign[] = [
  {
    id: '10000000-0000-4000-8000-000000000001',
    name: 'Démo — Halloween Badaboum',
    image_url: 'https://placehold.co/1200x300/png?text=HALLOWEEN+%E2%80%94+BADABOUM',
    image_width: 1200,
    image_height: 300,
    link_url: 'https://badaboum.paris/',
    alt: 'Halloween au Badaboum',
    starts_at: '2026-10-20T00:00:00+02:00',
    ends_at: '2026-11-01T06:00:00+01:00',
    brand_ids: ['badaboum'],
    include_emails: [],
    exclude_emails: [],
    priority: 0,
    active: true,
    utm_auto: false,
    updated_at: '2026-09-11T00:00:00Z',
  },
  {
    id: '10000000-0000-4000-8000-000000000002',
    name: 'Démo — Réveillon groupe',
    image_url: 'https://placehold.co/1200x300/png?text=NOUVEL+AN+%E2%80%94+BONJOUR%2FBONSOIR',
    image_width: 1200,
    image_height: 300,
    link_url: 'https://bonjourbonsoir.paris/',
    alt: 'Nouvel An Bonjour/Bonsoir',
    starts_at: '2026-12-01T00:00:00+01:00',
    ends_at: '2027-01-01T08:00:00+01:00',
    brand_ids: [],
    include_emails: [],
    exclude_emails: [],
    priority: 0,
    active: true,
    utm_auto: true,
    updated_at: '2026-09-11T00:00:00Z',
  },
];
